/* Import TinyMCE */
import tinymce from 'tinymce'

/* Default icons are required. After that, import custom icons if applicable */
import 'tinymce/icons/default/icons.min.js'

/* Required TinyMCE components */
import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/models/dom/model.min.js'

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.js'

/* Import plugins */
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/quickbars'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/table'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/code'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/media'
import 'tinymce/plugins/help'
import 'tinymce/plugins/help/js/i18n/keynav/en.js'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/emoticons/js/emojis.js'
import 'tinymce/plugins/emoticons/js/emojiimages.js'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/save'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/autoresize'

/* Import premium plugins */
/* NOTE: Download separately and add these to /src/plugins */
/* import './plugins/<plugincode>' */
import './tinymce/plugins/powerpaste/plugin.min.js'
import './tinymce/plugins/powerpaste/js/wordimport.js'
import './tinymce/plugins/editimage/plugin.min.js'
import './tinymce/plugins/advtable/plugin.min.js'

/* content UI CSS is required */
import 'tinymce/skins/ui/oxide/skin.js'
import 'tinymce/skins/ui/oxide/content.js'

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
import 'tinymce/skins/content/default/content.js'

/* Initialize TinyMCE */
export function render() {
    tinymce.init({
        license_key: 'gpl',
        selector: 'textarea.tinymce',
        plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'pagebreak', 'charmap', 'preview',
            'quickbars', 'searchreplace', 'anchor', 'table', 'fullscreen', 'wordcount',
            'visualblocks', 'code', 'insertdatetime', 'media',  'help',
            'pagebreak',  'emoticons', 'autosave', 'save',
            'directionality', 'nonbreaking', 'codesample',
            'visualchars', 'autoresize',
            // premium plugins
            'powerpaste', 'editimage', 'advtable',
        ].join(' '), // Include all available plugins

        toolbar: [
            'undo redo | bold italic underline strikethrough | forecolor backcolor | ' +
            'alignleft aligncenter alignright alignjustify | fontselect fontsizeselect formatselect | ' +
            'outdent indent | numlist bullist | link image media table | ' +
            'pagebreak codesample | charmap emoticons | fullscreen preview save print | ' +
            'visualblocks visualchars code | insertdatetime template | searchreplace'
        ].join(' '), // Include as many toolbar options as possible

        menubar: 'file edit view insert format tools table help', // Show all menu options

        contextmenu: 'link image inserttable | cell row column deletetable', // Right-click menu

        height: 600, // Set a taller height for easier editing

        branding: false, // Removes "Powered by TinyMCE"
        promotion: false, // Removes "Upgrade" to premium link
        image_advtab: true, // Advanced image options

        // Optional skin and content CSS (you can customize these if needed)
        skin_url: 'default',
        content_css: 'default',

        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        quickbars_insert_toolbar: 'image media table codesample',
        autosave_interval: '30s', // Automatically save draft every 30 seconds
    });
}
